import React, { useState, useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import { StoreContext } from "../../context/StoreContext";
import { SearchInput } from "../../components/componentsList";
import { useHistory } from "react-router-dom";

const ExtendedSearch = () => {
  const { state, actions } = useContext(StoreContext);
  const history = useHistory();
  const extendedSearchRoot = document.getElementById("appExtendedSearch");

  const [extendedOption, setExtendedOption] = useState({
    mobileOpen: false,
    searchButton: state.search.inputFound,
    list: [],
    qualitySchemesUsed: [],
    sessionTaken: false,
    loaded: false,
  });

  useEffect(() => {
    setExtendedOption({
      ...extendedOption,
      loaded: true,
    });
    if (extendedOption.loaded) {
      setExtendedOption({
        ...extendedOption,
        qualitySchemesUsed: state.search.suggestions.Kwaliteitsregelingen,
      });
    }
  }, [state.search.searchInput]);

  const getQualitySchemesFiltered = () => {
    if (
      sessionStorage.getItem("TNLZqualitySchemesFiltered") &&
      !extendedOption.sessionTaken
    ) {
      setExtendedOption({
        ...extendedOption,
        qualitySchemesUsed: JSON.parse(
          sessionStorage.getItem("TNLZqualitySchemesFiltered")
        ),
        sessionTaken: true,
      });
      sessionStorage.setItem("TNLZqualitySchemesFiltered", "");
    } else {
      setTimeout(() => {
        getQualitySchemesFiltered();
      }, 100);
    }
  };

  if (!extendedOption.sessionTaken) {
    getQualitySchemesFiltered();
  }

  function checkForZipcode() {
    const place =
      state.search.searchInput && state.search.searchInput.place
        ? state.search.searchInput.place.Name
        : "";
    const placeInput = place
      .replace(/\./g, "")
      .replace(/ /g, "")
      .substring(0, 4);
    const placeNumber = placeInput.match("^[0-9]+$") || [];

    return placeNumber.length > 0 ? true : false;
  }

  const activateSearch = (e) => {
    process.env.Module === "dev"
      ? history.push("/membersearch/results")
      : (window.location.href =
          "https://www.technieknederland.nl/ledenzoek-resultaat");
  };

  function storeInput(value, inputCategory) {
    actions.setSearchInput(value, inputCategory);
    value.Name.length > 0
      ? setExtendedOption({ ...extendedOption, searchButton: true })
      : setExtendedOption({ ...extendedOption, searchButton: false });
  }

  function sortSuggestions(dataToSort) {
    return dataToSort.sort((a, b) => (a.Name > b.Name ? 1 : -1));
  }

  function selectDistance(e) {
    actions.setRadiusDistance(parseInt(e.target.value));
  }

  function selectKwaliteitsregeling(e) {
    let qualityScheme =
      e.target.value === "Selecteer kwaliteitsregeling" ? "" : e.target.value;
    actions.setSearchQualityScheme(qualityScheme);
  }

  function toggleMobile() {
    setExtendedOption({
      ...extendedOption,
      mobileOpen: !extendedOption.mobileOpen,
    });
  }

  return ReactDOM.createPortal(
    <section className="search-box extended">
      {state.search.suggestionsLoaded &&
        state.search.suggestions &&
        state.search.searchInput && (
          <>
            <SearchInput
              inputID="company"
              placeHolder="Zoek op opdracht of bedrijf"
              classes="company"
              suggestions={[
                {
                  keywords: sortSuggestions(
                    state.search.suggestions.MappingKeywordAttribute
                  ),
                },
                {
                  qualitySchemes: sortSuggestions(
                    state.search.suggestions.Kwaliteitsregelingen
                  ),
                },
                {
                  companies: sortSuggestions(
                    state.search.suggestions.Companies
                  ),
                },
              ]}
              iconFunction={(e) => activateSearch(e)}
              storeInput={storeInput}
              defaultValueForInput={
                state.search.searchInput.company
                  ? state.search.searchInput.company
                  : {}
              }
              useGeo={false}
              label="Opdracht of bedrijfsnaam"
              tooltipIcon=""
            />
            <SearchInput
              inputID="place"
              placeHolder="Vul uw plaats of postcode in"
              classes="location"
              suggestions={[
                { Places: sortSuggestions(state.search.suggestions.Places) },
              ]}
              storeInput={storeInput}
              defaultValueForInput={
                state.search.searchInput.place
                  ? state.search.searchInput.place
                  : {}
              }
              useGeo={true}
              label="Locatie"
              tooltipIcon="Bepaal mijn coördinaten"
            />
            {checkForZipcode() && (
              <div className="field radius">
                <select
                  name="radius"
                  className="listbox"
                  onChange={(e) => selectDistance(e)}
                >
                  <option
                    selected={state.search.searchInput.distance === 5}
                    value="5"
                  >
                    Tot 5 km
                  </option>
                  <option
                    selected={state.search.searchInput.distance === 10}
                    value="10"
                  >
                    Tot 10 km
                  </option>
                  <option
                    selected={state.search.searchInput.distance === 20}
                    value="20"
                  >
                    Tot 20 km
                  </option>
                  <option
                    selected={state.search.searchInput.distance === 50}
                    value="50"
                  >
                    Tot 50 km
                  </option>
                </select>
              </div>
            )}
            {state.search.inputFound && extendedOption.qualitySchemesUsed && (
              <div className="field recognition">
                <label>Certificaten</label>
                <div className="autocomplete-container input">
                  <select
                    onChange={(e) => selectKwaliteitsregeling(e)}
                    value={state.search.searchInput.qualityScheme}
                  >
                    <option value="0">Selecteer kwaliteitsregeling</option>
                    {extendedOption.qualitySchemesUsed.map(
                      (regeling, index) => (
                        <option key={index} value={regeling.Id}>
                          {regeling.Name}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
            )}
            {!state.search.inputFound && (
              <div className="field recognition">
                <label>Certificaten</label>
                <div className="autocomplete-container input">
                  <select
                    onChange={(e) => selectKwaliteitsregeling(e)}
                    value={state.search.searchInput.qualityScheme}
                  >
                    <option value="0">Selecteer kwaliteitsregeling</option>
                    {state.search.suggestions.Kwaliteitsregelingen.map(
                      (regeling, index) => (
                        <option key={index} value={regeling.Id}>
                          {regeling.Name}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
            )}
            <section
              className={
                extendedOption.mobileOpen
                  ? "is-active mobile-search"
                  : "mobile-search"
              }
            >
              <h3 onClick={(e) => toggleMobile()}>Zoekresultaten filteren</h3>
              {extendedOption.mobileOpen && (
                <>
                  <SearchInput
                    inputID="place"
                    placeHolder="Vul uw plaats of postcode in"
                    classes="location"
                    suggestions={[
                      {
                        Places: sortSuggestions(
                          state.search.suggestions.Places
                        ),
                      },
                    ]}
                    storeInput={storeInput}
                    defaultValueForInput={
                      state.search.searchInput.place
                        ? state.search.searchInput.place
                        : {}
                    }
                    useGeo={true}
                    label="Locatie"
                    tooltipIcon="Bepaal mijn coördinaten"
                  />
                  {checkForZipcode() && (
                    <div className="field radius">
                      <select
                        name="radius"
                        className="listbox"
                        onChange={(e) => selectDistance(e)}
                      >
                        <option
                          selected={state.search.searchInput.distance === 5}
                          value="5"
                        >
                          Tot 5 km
                        </option>
                        <option
                          selected={state.search.searchInput.distance === 10}
                          value="10"
                        >
                          Tot 10 km
                        </option>
                        <option
                          selected={state.search.searchInput.distance === 20}
                          value="20"
                        >
                          Tot 20 km
                        </option>
                        <option
                          selected={state.search.searchInput.distance === 50}
                          value="50"
                        >
                          Tot 50 km
                        </option>
                      </select>
                    </div>
                  )}

                  {state.search.inputFound &&
                    state.results.KwaliteitsregelingenFiltered &&
                    state.results.KwaliteitsregelingenFiltered.length > 0 && (
                      <div className="field recognition">
                        <label>Certificaten</label>
                        <div className="autocomplete-container input">
                          <select
                            onChange={(e) => selectKwaliteitsregeling(e)}
                            value={state.search.searchInput.qualityScheme}
                          >
                            <option value="0">
                              Selecteer kwaliteitsregeling
                            </option>
                            {state.results.KwaliteitsregelingenFiltered.map(
                              (regeling, index) => (
                                <option key={index} value={regeling.Id}>
                                  {regeling.Name}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>
                    )}
                  {!state.results.KwaliteitsregelingenFiltered && (
                    <div className="field recognition">
                      <label>Certificaten</label>
                      <div className="autocomplete-container input">
                        <select
                          onChange={(e) => selectKwaliteitsregeling(e)}
                          value={state.search.searchInput.qualityScheme}
                        >
                          <option value="0">
                            Selecteer kwaliteitsregeling
                          </option>
                          {state.search.suggestions.Kwaliteitsregelingen.map(
                            (regeling, index) => (
                              <option key={index} value={regeling.Id}>
                                {regeling.Name}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>
                  )}
                </>
              )}
            </section>
            {extendedOption.searchButton && (
              <a className="btn" onClick={activateSearch}>
                Vind een vakman
              </a>
            )}
            {!extendedOption.searchButton && (
              <a className="btn disabled" onClick={activateSearch}>
                Vind een vakman
              </a>
            )}
          </>
        )}
    </section>,
    extendedSearchRoot
  );
};

export { ExtendedSearch };
